export default "__VITE_ASSET__Bu_2qD1L__"